module.exports = __webpack_public_path__ + "img/pr-8.50d3e51b.png";